<template>
  <div class="app-root">
    <router-view />
    <transition name="global-loading-fade">
      <div v-if="$store.state.app.globalLoading" class="global-loading">
        <div class="global-loading__card"><span class="table-loading-spinner"><i></i><i></i><i></i></span><strong>正在切换页面</strong></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
